import React, { useState, useEffect } from "react";
import Clock from "../assets/clock-icon.png";
import productTemp from "../assets/productTemp.png";
import ambientTemp from "../assets/ambientTemp.png";
import CountUp from "react-countup";
import { settings } from "../views/ProgramMode";

function ProductTemp({ stage, setting }) {

  const time = (fontSize, iconSize, marginRight, { time_s }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={Clock} style={{ marginRight }} width={iconSize} alt="" />
      {time_s &&
        <h3 style={{ fontSize }}>{time_s}</h3>
      }

      <p style={{ paddingTop: 10, fontSize, marginLeft: 10 }}>
        (Time elapsed)
      </p>
    </div>
  )

  const prodTemp = (fontSize, iconSize, marginRight, { product_temperature_f }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={productTemp}
        style={{ marginRight }}
        width={iconSize}
        alt=""
      />
      {product_temperature_f &&
        <h3 style={{ fontSize }} className="title">
          <CountUp
            start={0}
            end={product_temperature_f}
            duration={1}
          />
          ºF
        </h3>
      }
      <p style={{ paddingBottom: 30, marginLeft: 10, fontSize: fontSize / 3 }}>
        Actual Product Temp
      </p>
    </div>
  )

  const grillTemp = (fontSize, iconSize, marginRight, { grill_temperature_f }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={ambientTemp}
        style={{ marginRight }}
        width={iconSize}
        alt=""
      />
      {grill_temperature_f &&
        <h3 style={{ fontSize }} className="title">
          <CountUp
            start={0}
            end={grill_temperature_f}
            duration={1}
          />
          ºF
        </h3>
      }
      <p style={{ paddingBottom: 30, marginLeft: 10, fontSize: fontSize / 3 }}>
        Actual Grill Temp
      </p>
    </div>
  )

  const [display, _] = useState([time, prodTemp, grillTemp])

  return (
    <>
      {display[0](20, 30, 30, stage)}
      {display[1](40, 80, 80, stage)}
      <hr width="80%" style={{ borderTop: '3px solid #bbb' }} />
      {display[2](30, 40, 30, stage)}
    </>
  );
}

export default ProductTemp;
